export const getTokenAllocation = (planName: string) => {
  switch (planName) {
    case 'Basic Bruker':
      return '50,000';
    case 'Pro Bruker':
      return '100,000';
    default:
      return '5,000';
  }
};

export const getTokenTopUpDiscount = (planName: string) => {
  switch (planName) {
    case 'Pro Bruker':
      return '20%';
    case 'Basic Bruker':
      return '10%';
    default:
      return '0%';
  }
};

export const getDocumentGeneration = (planName: string) => {
  switch (planName) {
    case 'Basic Bruker':
      return '10 per måned';
    case 'Pro Bruker':
      return 'Ubegrenset';
    default:
      return '1 per måned';
  }
};

export const getAIAssistance = (planName: string) => {
  switch (planName) {
    case 'Basic Bruker':
      return 'Full tilgang';
    case 'Pro Bruker':
      return 'Prioritert tilgang med avanserte AI-modeller';
    default:
      return '1 interaksjon per måned';
  }
};

export const getCaseCreation = (planName: string) => {
  switch (planName) {
    case 'Basic Bruker':
    case 'Pro Bruker':
      return 'Ubegrenset';
    default:
      return '1 sak per måned';
  }
};